import { motion, useReducedMotion } from "framer-motion";
import { SITE } from "../data/site";

// The Next-G logo as a 3D planet: rotating surface inside a spherical mask,
// specular highlight + terminator shadow + glowing atmosphere.
export const LogoPlanet = ({ size = 170, label, testid = "logo-planet" }) => {
  const reduce = useReducedMotion();
  return (
    <div data-testid={testid} className="relative flex flex-col items-center gap-3">
      <motion.div
        className="relative"
        style={{ width: size, height: size }}
        animate={reduce ? {} : { y: [0, -12, 0] }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
      >
        {/* atmosphere */}
        <div
          aria-hidden="true"
          className="absolute -inset-5 rounded-full"
          style={{
            background:
              "radial-gradient(circle, rgba(201,155,63,0.4), rgba(233,180,76,0.14) 55%, transparent 72%)",
            filter: "blur(8px)",
          }}
        />
        {/* spherical body with rotating surface */}
        <div className="absolute inset-0 overflow-hidden rounded-full ring-1 ring-gold/50">
          <div
            className={`absolute inset-y-0 left-0 flex ${reduce ? "" : "planet-surface"}`}
            style={{ width: size * 2 }}
            aria-hidden="true"
          >
            <img src={SITE.logo} alt="" className="h-full w-1/2 object-cover" draggable="false" />
            <img src={SITE.logo} alt="" className="h-full w-1/2 object-cover" draggable="false" />
          </div>
          {/* 3D shading: specular + terminator */}
          <div
            aria-hidden="true"
            className="absolute inset-0 rounded-full"
            style={{
              background:
                "radial-gradient(circle at 32% 26%, rgba(255,255,255,0.4), transparent 40%), radial-gradient(circle at 74% 78%, rgba(0,0,0,0.55), transparent 62%)",
            }}
          />
          <div
            aria-hidden="true"
            className="absolute inset-0 rounded-full"
            style={{ boxShadow: "inset -20px -16px 36px rgba(0,0,0,0.62), inset 10px 10px 24px rgba(255,255,255,0.16)" }}
          />
        </div>
      </motion.div>
      {label && (
        <span className="rounded-full border border-gold/40 bg-espresso/90 px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.26em] text-gold-soft shadow-[0_0_22px_rgba(201,155,63,0.35)]">
          {label}
        </span>
      )}
    </div>
  );
};
